var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3F4851",
  d: "M12.333.667H1.666C.933.667.34 1.267.34 2l-.007 8c0 .733.6 1.333 1.333 1.333h10.667c.733 0 1.333-.6 1.333-1.333V2c0-.733-.6-1.333-1.333-1.333M12.066 3.5 7.353 6.447a.67.67 0 0 1-.707 0L1.933 3.5a.567.567 0 1 1 .6-.96L7 5.333l4.466-2.793a.567.567 0 1 1 .6.96"
})));
export { SvgEmail as ReactComponent };
export default __webpack_public_path__ + "Email.240f6cb1.svg";